import { createContext } from 'react'

import { BeforeInstallPromptEvent } from '@app/types'

export interface InstallAppContextType {
  event: BeforeInstallPromptEvent | null
  setEvent: React.Dispatch<
    React.SetStateAction<BeforeInstallPromptEvent | null>
  >
}

const initialContext: InstallAppContextType = {
  event: null,
  setEvent: () => undefined,
}

export const InstallAppContext = createContext(initialContext)
